import { useCallback } from 'react';
import { shallowEqual } from 'react-redux';
import { SalesPitchActions, useActions, useAppSelector } from '@web-common/state/createStore';
const useState2ReduxMock = (stateName, reducerName = '') => {
    const state = useAppSelector(_state => _state.salesPitchReducer[stateName], shallowEqual);
    const reducer = useActions(SalesPitchActions)[reducerName || 'doUpdateAny'];
    const setter = useCallback((val) => {
        if (reducer) {
            if (typeof val === 'function') {
                reducer(reducerName ? val(state) : { name: stateName, data: val(state) });
            }
            else {
                reducer(reducerName ? val : { name: stateName, data: val });
            }
        }
        else {
            console.error('REDUCER IS NOT VALID', stateName, reducerName);
        }
    }, [reducer, reducerName, stateName]);
    return [state, setter];
};
export default useState2ReduxMock;
